

// // Optimized and functional OldCar component using function components with full table, date filtering, and pagination
// import React, { useState, useEffect, useMemo } from "react";
// import { Link, useParams } from "react-router-dom";
// import _ from "lodash";
// import dayjs from "dayjs";
// import "./OldCars.css"; // We'll create this CSS file

// const OldCar = ({ login, client, viewAllOldCar, deleteOldCar, updateOldCarStatus }) => {
//   const { id } = useParams();
//   const [searchInput, setSearchInput] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [selectedRange, setSelectedRange] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [view, setView] = useState(false);
//   const [reject, setReject] = useState(false);
//   const [editStatus, setEditStatus] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [oldCarId, setOldCarId] = useState("");
//   const [status, setStatus] = useState("");

//   const debouncedSearch = useMemo(() =>
//     _.debounce(() => {
//       viewAllOldCar(
//         login.token,
//         login.user_id,
//         searchInput,
//         page,
//         rowsPerPage,
//         startDate,
//         endDate,
//         selectedStatus
//       );
//     }, 300),
//     [searchInput, page, rowsPerPage, startDate, endDate, selectedStatus]
//   );

//   useEffect(() => {
//     viewAllOldCar(
//       login.token,
//       login.user_id,
//       searchInput,
//       page,
//       rowsPerPage,
//       startDate,
//       endDate,
//       selectedStatus
//     );
//   }, []);

//   useEffect(() => {
//     debouncedSearch();
//     return debouncedSearch.cancel;
//   }, [searchInput, debouncedSearch]);

//   const handleDateRangeChange = (e) => {
//     const today = dayjs().startOf("day");
//     const range = e.target.value;
//     setSelectedRange(range);
//     let start = "";
//     let end = "";

//     switch (range) {
//       case "today":
//         start = end = today.format("YYYY-MM-DD");
//         break;
//       case "yesterday":
//         start = end = today.subtract(1, "day").format("YYYY-MM-DD");
//         break;
//       case "7days":
//         start = today.subtract(6, "day").format("YYYY-MM-DD");
//         end = today.format("YYYY-MM-DD");
//         break;
//       case "thismonth":
//         start = today.startOf("month").format("YYYY-MM-DD");
//         end = today.format("YYYY-MM-DD");
//         break;
//       default:
//         start = end = "";
//     }

//     setStartDate(start);
//     setEndDate(end);
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleDelete = () => {
//     deleteOldCar(login.token, login.user_id, oldCarId, page, rowsPerPage);
//     setReject(false);
//     setOldCarId("");
//   };

//   const handleStatusSave = () => {
//     updateOldCarStatus(login.token, login.user_id, selectedEmployee._id, status, page, rowsPerPage);
//     setEditStatus(false);
//     setStatus("");
//   };

//   const allOldCars = client?.allOldCar || [];
//   const totalCount = client?.allOldCarLength || 0;

//   return (
//     <div className="oldcar-container">
//       {/* Add Button */}
//       <div className="oldcar-header">
//         <Link to="/addinfo" className="add-button">
//           <button className="btn btn-primary">
//             <span className="btn-icon">+</span>
//             Add Old Car
//           </button>
//         </Link>
//       </div>

//       {/* Filters Section */}
//       <div className="filters-section">
//         <div className="filters-grid">
//           {/* Search */}
//           <div className="filter-item">
//             <div className="search-box">
//               <span className="search-icon"></span>
//               <input
//                 type="text"
//                 placeholder="Search"
//                 value={searchInput}
//                 onChange={(e) => setSearchInput(e.target.value)}
//                 className="search-input"
//               />
//             </div>
//           </div>

//           {/* Date Filter */}
//           <div className="filter-item">
//             <select
//               value={selectedRange}
//               onChange={handleDateRangeChange}
//               className="filter-select"
//             >
//               <option value="">Date Filter</option>
//               <option value="today">Today</option>
//               <option value="yesterday">Yesterday</option>
//               <option value="7days">Last 7 Days</option>
//               <option value="thismonth">This Month</option>
//               <option value="Custom">Custom</option>
//             </select>
//           </div>

//           {/* Custom Date Range */}
//           {selectedRange === "Custom" && (
//             <>
//               <div className="filter-item">
//                 <input
//                   type="date"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   className="date-input"
//                 />
//               </div>
//               <div className="filter-item">
//                 <input
//                   type="date"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   className="date-input"
//                 />
//               </div>
//             </>
//           )}

//           {/* Status Filter */}
//           <div className="filter-item">
//             <select
//               value={selectedStatus}
//               onChange={(e) => setSelectedStatus(e.target.value)}
//               className="filter-select"
//             >
//               <option value="">All Status</option>
//               {["Sale", "Rejected", "Active"].map((s) => (
//                 <option key={s} value={s}>{s}</option>
//               ))}
//             </select>
//           </div>

//           {/* Pagination */}
//           <div className="pagination-top">
//             <div className="pagination-controls">
//               <span className="pagination-info">
//                 {totalCount > 0 ? `1-${Math.min(rowsPerPage, totalCount)} of ${totalCount}` : '0 items'}
//               </span>
//               <select
//                 value={rowsPerPage}
//                 onChange={handleChangeRowsPerPage}
//                 className="rows-select"
//               >
//                 <option value={5}>5</option>
//                 <option value={10}>10</option>
//                 <option value={25}>25</option>
//                 <option value={50}>50</option>
//                 <option value={100}>100</option>
//                 <option value={totalCount}>All</option>
//               </select>
//               <div className="page-buttons">
//                 <button
//                   onClick={() => handleChangePage(null, page - 1)}
//                   disabled={page === 0}
//                   className="page-btn"
//                 >
//                   ‹
//                 </button>
//                 <button
//                   onClick={() => handleChangePage(null, page + 1)}
//                   disabled={(page + 1) * rowsPerPage >= totalCount}
//                   className="page-btn"
//                 >
//                   ›
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table-section">
//         <div className="table-container">
//           <table className="data-table">
//             <thead>
//               <tr>
//                 {["Sl No", "Brand", "Car Name", "Car Type", "Price", "Discounted Price", "Date", "Status", "Actions"].map((h, i) => (
//                   <th key={i} className="table-header">
//                     {h}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {allOldCars?.map((item, index) => {
//                 const date = new Date(item.createdAt).toLocaleDateString();
//                 const time = new Date(item.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//                 return (
//                   <tr key={item._id} className="table-row">
//                     <td className="table-cell">{index + 1}</td>
//                     <td className="table-cell">{item.brand}</td>
//                     <td className="table-cell">{item.carName}</td>
//                     <td className="table-cell">{item.carType}</td>
//                     <td className="table-cell">{item.price}</td>
//                     <td className="table-cell">{item.discountedPrice}</td>
//                     <td className="table-cell">
//                       <div className="date-time">
//                         <div>{date}</div>
//                         <div className="time">{time}</div>
//                       </div>
//                     </td>
//                     <td className="table-cell">
//                       <div className="status-cell">
//                         <span>{item.status}</span>
//                         <button 
//                           className="icon-btn edit-btn"
//                           onClick={() => { setSelectedEmployee(item); setEditStatus(true); }}
//                           title="Edit Status"
//                         >
//                           ✏️
//                         </button>
//                       </div>
//                     </td>
//                     <td className="table-cell">
//                       <div className="action-buttons">
//                         <Link to={`/view/${item._id}`}>
//                           <button className="icon-btn view-btn" title="View">
//                             👁️
//                           </button>
//                         </Link>
//                         <button 
//                           className="icon-btn delete-btn"
//                           onClick={() => { setOldCarId(item._id); setReject(true); }}
//                           title="Delete"
//                         >
//                           🗑️
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Delete Dialog */}
//       {reject && (
//         <div className="dialog-overlay">
//           <div className="dialog">
//             <div className="dialog-header">
//               <h3>Confirm Delete</h3>
//             </div>
//             <div className="dialog-content">
//               <p>Are you sure you want to delete this old car?</p>
//             </div>
//             <div className="dialog-actions">
//               <button onClick={() => setReject(false)} className="btn btn-secondary">No</button>
//               <button onClick={handleDelete} className="btn btn-danger">Yes</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Status Edit Dialog */}
//       {editStatus && (
//         <div className="dialog-overlay">
//           <div className="dialog">
//             <div className="dialog-header">
//               <h3>Edit Old Car Status</h3>
//             </div>
//             <div className="dialog-content">
//               <select
//                 value={status}
//                 onChange={(e) => setStatus(e.target.value)}
//                 className="status-select"
//               >
//                 <option value="">Select Status</option>
//                 {["Sale", "Rejected"].map((s) => (
//                   <option key={s} value={s}>{s}</option>
//                 ))}
//               </select>
//             </div>
//             <div className="dialog-actions">
//               <button onClick={() => setEditStatus(false)} className="btn btn-secondary">Cancel</button>
//               <button onClick={handleStatusSave} className="btn btn-primary">Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OldCar;



import React, { useEffect, useState, useCallback } from "react";
import DataTable from "../Components/Common/DataTable";
import PremiumFilterBar from "../Components/Common/PremiumFilterBar";
import DeleteButton from "../Components/Common/DeleteButton";
import ViewButton from "./Common/ViewButton";
import { Link } from "react-router-dom";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { Car, CheckCircle, XCircle, Clock, Trash2, Eye, Edit3 } from "lucide-react";
import "./OldCars.css";

const statusColors = {
  Available: { class: "status-available", icon: <CheckCircle size={14} /> },
  Sold: { class: "status-sold", icon: <Clock size={14} /> },
  Rejected: { class: "status-rejected", icon: <XCircle size={14} /> },
};

export default function OldCars({
  login,
  client,
  viewAllOldCar,
  deleteOldCar,
  updateOldCarStatus,
  snackbar,
  close_snack_bar
}) {
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(20);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [editingStatusId, setEditingStatusId] = useState(null);

  const fetchData = useCallback(() => {
    viewAllOldCar(
      login.token,
      login.user_id,
      searchInput,
      page,
      rowsPerPage,
      startDate,
      endDate,
      selectedStatus
    );
  }, [login, searchInput, page, rowsPerPage, startDate, endDate, selectedStatus, viewAllOldCar]);

  useEffect(() => {
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [searchInput, fetchData]);

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, startDate, endDate, selectedStatus, fetchData]);

  const oldcars = client?.allOldCar || [];
  // const oldcarsCount = client?.allOldCarLength || 0;
  const oldcarsCount = oldcars.length;
  const pageLength = client?.oldcars_length || 0;

  // Calculate statistics
  const stats = {
    total: oldcarsCount,
    available: oldcars.filter(c => c.status === "Available").length, // Note: This only counts current page, ideally should come from backend
    sold: oldcars.filter(c => c.status === "Sold").length
  };

  const columns = [
    {
      header: "Vehicle Details",
      key: "carName",
      render: (row) => (
        <div className="car-ident">
          <span className="name">{row.carName}</span>
          <span className="brand">{row.brand} • {row.carType}</span>
        </div>
      )
    },
    {
      header: "Pricing",
      key: "price",
      render: (row) => (
        <div className="price-tag">
          <span className="old-price">₹{row.price}</span>
          <span>₹{row.discountedPrice}</span>
        </div>
      )
    },
    { header: "Fuel Type", key: "fuelType" },
    {
      header: "Kms Driven",
      key: "kilometer",
      render: (row) => `${row.kilometer} km`
    },
    {
      header: "Created Date",
      key: "createdAt",
      render: (row) => {
        const date = new Date(row.createdAt);
        return (
          <div style={{ display: "flex", flexDirection: "column", fontSize: "12px", color: "var(--text-muted)" }}>
            <span>{date.toLocaleDateString()}</span>
            <span>{date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
          </div>
        );
      },
    },
    {
      header: "Status",
      key: "status",
      render: (row) => {
        const isEditing = editingStatusId === row._id;
        const statusCfg = statusColors[row.status] || { class: "", icon: null };

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {isEditing ? (
              <select
                className="premium-select"
                style={{ padding: "4px 8px", fontSize: "12px", borderRadius: '4px' }}
                value={row.status}
                autoFocus
                onBlur={() => setEditingStatusId(null)}
                onChange={(e) => {
                  updateOldCarStatus(login.token, login.user_id, row._id, e.target.value, page, rowsPerPage);
                  setEditingStatusId(null);
                }}
              >
                <option value="Available">Available</option>
                <option value="Sold">Sold</option>
                <option value="Rejected">Rejected</option>
              </select>
            ) : (
              <span
                className={`status-pill ${statusCfg.class}`}
                onClick={() => setEditingStatusId(row._id)}
                style={{ cursor: "pointer" }}
              >
                {row.status}
              </span>
            )}
          </div>
        );
      },
    },
    {
      header: "Actions",
      key: "actions",
      render: (row) => (
        <div className="action-group">
          <Link to={`/view/${row._id}`} style={{ textDecoration: 'none' }}>
            <button className="action-btn" title="View Details">
              <Eye size={16} />
            </button>
          </Link>
          <Link to={`/edit/${row._id}`} style={{ textDecoration: 'none' }}>
            <button className="action-btn" title="Edit Vehicle">
              <Edit3 size={16} />
            </button>
          </Link>
          <DeleteButton
            item={row}
            viewName="Old Car"
            onDelete={(item) => deleteOldCar(login.token, login.user_id, item._id, page, rowsPerPage)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="oldcar-container">
      {/* Summary Cards */}
      <div className="summary-cards">
        <div className="summary-card">
          <div className="card-icon" style={{ background: 'var(--primary)' }}>
            <Car size={24} />
          </div>
          <div className="card-info">
            <h3>Total Vehicles</h3>
            <p className="count">{oldcarsCount}</p>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon" style={{ background: '#059669' }}>
            <CheckCircle size={24} />
          </div>
          <div className="card-info">
            <h3>Ready for Sale</h3>
            <p className="count">{stats.available}</p>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon" style={{ background: '#64748b' }}>
            <Clock size={24} />
          </div>
          <div className="card-info">
            <h3>Sold Out</h3>
            <p className="count">{stats.sold}</p>
          </div>
        </div>
      </div>

      <PremiumFilterBar
        title="Inventory Management"
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        onDateChange={({ start, end }) => {
          setStartDate(start);
          setEndDate(end);
        }}
        extraElement={
          <Link to="/addinfo" style={{ textDecoration: "none" }}>
            <button className="premium-button-primary">
              <span style={{ fontSize: "18px", fontWeight: 'bold' }}>+</span>
              New Listing
            </button>
          </Link>
        }
      />

      <div className="premium-listing-card">
        <DataTable
          columns={columns}
          data={oldcars}
          page={page}
          totalPage={pageLength}
          onPageChange={(p) => setPage(p)}
          rowsPerPage={rowsPerPage}
        />
      </div>

      <LoaderCon />
      <Snackbar1
        open={snackbar.response_received}
        close_snack_bar={() => close_snack_bar()}
        message={snackbar.message}
      />
    </div>
  );
}




